import { cn } from "@/lib/utils";

export function BrutalButton({ children, className, variant = "primary", size = "md", ...props }) {
  const variants = {
    primary: "btn-accent",
    blue: "bg-brand-blue text-white",
    dark: "bg-brand-ink text-white",
    white: "bg-white text-brand-ink",
    green: "bg-brand-green text-brand-ink",
    yellow: "bg-brand-yellow text-brand-ink",
    pink: "bg-brand-pink text-brand-ink",
    violet: "bg-brand-violet text-white",
    danger: "bg-red-500 text-white",
  };
  const sizes = { sm: "px-3 py-1.5 text-sm", md: "px-5 py-2.5 text-base", lg: "px-7 py-4 text-lg" };
  return (
    <button
      className={cn("brutal brutal-press ui-btn font-head font-bold inline-flex items-center justify-center gap-2 disabled:opacity-50 disabled:pointer-events-none",
        variants[variant], sizes[size], className)}
      {...props}>
      {children}
    </button>
  );
}

export function BrutalCard({ children, className, color = "white", ...props }) {
  const bg = { white: "bg-white", cream: "bg-brand-cream", green: "bg-brand-green", yellow: "bg-brand-yellow", pink: "bg-brand-pink", blue: "bg-brand-blue text-white", orange: "bg-brand-orange text-white" };
  return (
    <div className={cn("brutal rounded-xl p-4", bg[color], className)} {...props}>
      {children}
    </div>
  );
}

export function Pill({ children, className, ...props }) {
  return (
    <span className={cn("brutal-sm inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-bold font-head", className)} {...props}>
      {children}
    </span>
  );
}

export function SectionTitle({ children, sub }) {
  return (
    <div className="mb-4">
      <h2 className="font-head text-3xl font-black tracking-tight">{children}</h2>
      {sub && <p className="text-sm text-brand-ink/60 mt-1">{sub}</p>}
    </div>
  );
}

export function EmptyState({ icon: Icon, title, text }) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-14 px-6">
      <div className="brutal rounded-2xl bg-white p-5 mb-4">
        <Icon className="w-10 h-10" strokeWidth={2.5} />
      </div>
      <h3 className="font-head font-bold text-lg">{title}</h3>
      {text && <p className="text-sm text-brand-ink/60 mt-1 max-w-xs">{text}</p>}
    </div>
  );
}
